// this file is generated by update_shopify_store_data.py at 2026-06-22 20:30:51.169350
var courses = [
    {
        "course_id": "27022AD4-5070-EF11-9991-005056A7327D",
        "course_version": 3,
        "name": "CEN Online Review 3.0",
        "course_type": 1,
        "author_information": "",
        "description": "Developed by emergency nurses with experience passing the CEN exam and conducting review courses, this comprehensive course includes: 10 interactive, self-paced modules; practice pre- and post-test to evaluate your learning; and mobile-friendly anytime, anywhere accessibility.",
        "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss concepts related to the assessment of patients experiencing a variety of conditions and/or disease processes seen in the emergency department</li>\r\n    <li>Describe various patient presentations associated with those conditions and/or disease processes</li>\r\n    <li>Review appropriate interventions relevant to those conditions and/or disease processes</li>\r\n</ul>\r\nThe planners and presenters of this course have no relevant financial relationships with ineligible companies to disclose. Learners will be awarded 18.0 CNE contact hours upon completion of a pre-test, review of the entire course, completion of a post-test, and submitting an evaluation.<strong> Course expires 12/31/2027.</strong><br />\r\n<br />\r\nCEN&reg; is a registered trademark of the Board of Certification for Emergency Nursing (BCEN). ENA&rsquo;s use of such trademarks does not imply any affiliation with or endorsement by BCEN.",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D12F13F5-CF7A-11DC-8864-0015171353BD",
                "course_category_name": "Immunologic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                "course_category_name": "Sexual Abuse & Assault",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D6D72E5-07DB-E511-AA9E-005056B17E48",
                "course_category_name": "Neurological Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Intimate Partner Violence",
                "is_system_course_category": null
            },
            {
                "course_category_id": "37A67743-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Interactions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7F34B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Urinary Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EA123A29-20FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Genital Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CE9E1209-CE8C-EB11-80DF-005056B134EC",
                "course_category_name": "Diagnostic & Patient Monitoring Equipment",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8833B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Endocrine Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                "course_category_name": "Geriatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "261DA364-12FD-E611-B8ED-005056B13721",
                "course_category_name": "Urinary Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "906AE9FC-CB8C-EB11-80DF-005056B134EC",
                "course_category_name": "Psychiatric Medications",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E32CF83-389F-11DD-AD08-0015171C1B93",
                "course_category_name": "Neurological & Neurocognitive Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6E2117C1-CB9B-EC11-80F1-005056B150D4",
                "course_category_name": "Emergency Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3F4D9D32-F3FD-E611-BC44-005056B10E33",
                "course_category_name": "Correctional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                "course_category_name": "Cardiac Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "82A50AA9-9182-E211-B22E-0015171C1A75",
                "course_category_name": "Renal Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Behavioral Health Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                "course_category_name": "Patient Monitoring",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                "course_category_name": "Infectious Diseases",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DA6A4541-D28C-EB11-80DF-005056B134EC",
                "course_category_name": "Mandatory Reporting",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FC2D23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "EMTALA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3F5D55B4-EDF9-E611-AF66-005056B104B1",
                "course_category_name": "Renal Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Personal Protective Equipment",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A0CBF9A6-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Child Abuse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                "course_category_name": "Wound Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                "course_category_name": "Pediatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8F911403-4F70-EF11-9991-005056A7327D",
                "course_category_name": "ENA - CEN Online Review",
                "is_system_course_category": null
            },
            {
                "course_category_id": "142C23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Burn Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5A34B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Respiratory Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                "course_category_name": "Injuries",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Psychosocial Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6527E533-CFC9-E511-82AF-005056B150D3",
                "course_category_name": "Ear, Eye, Nose and Throat Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BD15A3F6-CB8C-EB11-80DF-005056B134EC",
                "course_category_name": "Respiratory Medications",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9533B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Digestive Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D9C04975-413C-11DD-9765-001517135727",
                "course_category_name": "Orthopedic Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4C33FC22-4F70-EF11-9991-005056A7327D",
                "course_category_name": "ENA: CEN Online Review",
                "is_system_course_category": null
            },
            {
                "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Obstetric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FA20BE9F-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Elder Abuse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "26EF2AA5-22FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Obstetric Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "92EA2F9B-CB9B-EC11-80F1-005056B150D4",
                "course_category_name": "Emergency Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B1D5F710-EFD0-E511-AEA0-005056B11FFF",
                "course_category_name": "Gastrointestinal Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                "course_category_name": "Course",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C908B5A-A9BA-E811-AB88-005056B1522B",
                "course_category_name": "Resuscitation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                "course_category_name": "Infant Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D565E997-1E26-E711-9EDE-005056B14F90",
                "course_category_name": "Diabetes Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6C9CBECF-07DB-E511-AA9E-005056B17E48",
                "course_category_name": "Orthopedic Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiac Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                "course_category_name": "Workforce Culture",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pain Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93823AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Vascular Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "58382785-93D1-E511-BF53-005056B122EA",
                "course_category_name": "Respiratory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                "course_category_name": "Psychiatric Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5636B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Trauma Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ADFB6B18-D5C9-E511-82AF-005056B150D3",
                "course_category_name": "Cultural Awareness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "<br />",
            "course_level_accreditation_statement": "<p style=\"text-align: center;\">The Emergency Nurses Association is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Unit #P0232.</p>\r\n<p style=\"text-align: center;\">The Emergency Nurses Association is approved by the California Board of Registered Nursing, Provider #2322.</p>",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 18.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];